// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__k2CV7","list":"BalanceDue_list__3NvtH","listRow":"BalanceDue_listRow__PntWb","total":"BalanceDue_total__2RbQ_"};